export const environment = {
	apiUrl: 'https://dev-api.taxcanary.com/',
	//  apiUrl: "https://stage-api.taxcanary.com/",
  //  apiUrl: "https://api.taxcanary.com/",
  BaseUrl: "https://taxcanary-dev.s3.amazonaws.com/",
  production: false,
  firebase: {
    apiKey: "AIzaSyCW28l1UgSzHuty8SwA0Je2Q9xBjbB70LM",
    authDomain: "tax-canery.firebaseapp.com",
    projectId: "tax-canery",
    storageBucket: "tax-canery.appspot.com",
    messagingSenderId: "747169763404",
    appId: "1:747169763404:web:4aeef9f99b4dc1099de4e9",
    measurementId: "G-BFH3CX84VD"
  },
};
